import React, { useEffect, useState } from 'react'
import Icon from 'meinian-package/src/component/icon'
import request from 'meinian-package/src/utils/request'
import classNames from 'classnames'
import useViewed from 'component/notice/useViewed'
import useSocketMessage from 'component/notice/useSocketMessage'
import { getJumpUrl } from 'component/notice/config'
import emitter, { EmitterEvents } from 'meinian-package/src/utils/emitter'
import { getRecentlyTimeText } from 'component/notice/messageCard'
import styles from './index.module.less'

export default () => {
  const [data, setData] = useState([])
  const fetchDataList = async () => {
    const res = await request.post(`/backend-api/notify/website/notify/page?start=${0}&pageSize=${3}`, { appCode: 'meinian' })
    setData([...res.resultList])
  }
  useSocketMessage(fetchDataList)
  useEffect(() => {
    fetchDataList()
  }, [])

  return <div className={styles['operation-panel-message']}>
    <div
      className="message-header"
    >
      <span>
        <Icon type="m-xiaoxi" className="message-header-left-icon" />
        <span className="text-color-1">消息通知</span>
      </span>
      <Icon
        type="m-Vxing_you"
        className="message-header-right-icon fill-white-bg"
        onClick={() => {
          emitter.emit(EmitterEvents.onShowMessageNotification, true)
        }}
      />
    </div>
    <div className="message-list">
      {
          data.length ? data.map(item => <MessageListItem
            item={item}
            onInit={() => {
              fetchDataList()
            }}
          />) : <div className="message-empty">暂无消息</div>
      }
    </div>
  </div>
}

const MessageListItem = ({ item, onInit }) => {
  const { onViewed } = useViewed(item, onInit)
  const recentlyTimeText = getRecentlyTimeText(item.createdAt)
  return <div
    className="message-list-item"
    onClick={() => {
      onViewed()
      const url = getJumpUrl(item)
      url && window.open(url)
    }}
  >
    <div className={classNames('message-list-item-text-wrap')}>
      <div className={classNames('message-list-item-point', { viewed: item.viewed })} />
      <div className={classNames('message-list-item-text', 'text-overflow', { viewed: item.viewed })}>{item.params.sender?.text}{item.title}-&quot;{item.content}&quot;{item.params?.inspiration?.text}</div>
    </div>
    <div className="message-list-item-recentlyTimeText">{recentlyTimeText}</div>
  </div>
}
